import { render, staticRenderFns } from "./message-column.vue?vue&type=template&id=63fbd836&scoped=true&"
import script from "./message-column.vue?vue&type=script&lang=js&"
export * from "./message-column.vue?vue&type=script&lang=js&"
import style0 from "./message-column.vue?vue&type=style&index=0&id=63fbd836&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fbd836",
  null
  
)

export default component.exports